import { getProductThumbnail } from 'common/api/thumbnails';

import {
    FETCH_PRODUCT_THUMBNAIL,
    FETCH_PRODUCT_THUMBNAIL_FAILURE,
    FETCH_PRODUCT_THUMBNAIL_SUCCESS,
} from '../actionTypes';
import { productThumbnailActions } from '../reducer';

export default (id) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(productThumbnailActions[FETCH_PRODUCT_THUMBNAIL]());

        getProductThumbnail(id)
            .then((response) => {
                dispatch(
                    productThumbnailActions[FETCH_PRODUCT_THUMBNAIL_SUCCESS](
                        response.data,
                    ),
                );
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(
                    productThumbnailActions[FETCH_PRODUCT_THUMBNAIL_FAILURE](
                        error.response.data.errors,
                    ),
                );
                reject();
            });
    });
